import React, { useContext, useState } from 'react'
import { FlexView, Card, Button, Modal } from '../../../components/common'
import styled from 'styled-components'
import documentIcon from '../../../assets/icons/sre-documents-icon.svg'
import AppIcon from '../../common/AppIcon'
import { TextArea, Input } from 'components/form'
import { JobDocumentsContext } from 'stores/JobDocumentsStore'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'

const Subtitle = styled.h3`
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 20px;
    text-align: justify;
    color: #777777;
    margin: 16px 0;
`

const FlexWrap = styled(FlexView)`
    flex-wrap: wrap;
`  

const IconButton = styled(Button)`  
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 27px;
    text-align: justify;
    display: flex;
    justify-content: center;
`

const DocPlaceholderImage = styled(AppIcon)`
    align-self: center;
    margin: 15px 0;
`


const DocPlaceholder = styled(Card)`
    cursor: pointer;
    max-width: 180px;
    margin: 8px 16px;
    overflow: hidden;
    transition: transform .2s ease-in-out;

    &:hover {
        transform: scale(1.05);
     }  
    & .lastModification {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 14px;
        margin: 0;
    }

    & .docName {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        margin: 8px 0;
        text-overflow: ellipsis;
        word-break: break-all;
    }

`

const CardMargin = styled(Card)`  
    margin: 10px 20px 30px 30px;
    flex-wrap: wrap;
`

const DocumentsQuickAccess = ({ docs, onDownloadClick }) => {
    const { setfileToUpload, isFileUploading, setFileIdToDownload, setFileDescriptionToUpload, setFilePipeToUpload } = useContext(JobDocumentsContext)
    const { t } = useTranslation()
    const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false)
    const [file, setFile] = useState({})
    const [fileDescription, setFileDescription] = useState('')
    const [filePipe, setFilePipe] = useState('')
    const { registryLog, registryLogOld } = useContext(UserContext)

    const onFileInputChange = (e) => {
        e.preventDefault()
        const filesObject = e.target.files
        const file = filesObject[0]
        if (file && file.size < 6000000) {
            // 5789840
            // console.log(file.size)
            setFile(file)
            setIsUploadDialogOpen(true)

        } else {
            toast.error(t("File is too big. Please contact an Administrator"))
        }
    }

    const uploadFile = () => {
        setFileDescriptionToUpload(fileDescription)
        setFilePipeToUpload(filePipe)
        setfileToUpload(file)
        closeModal()
    }

    const closeModal = () => {
        setFileDescription('')
        setFilePipe('')
        setIsUploadDialogOpen(false)
    }

    const onDocumentUploadClick = () => {
        if (document.getElementById("uploadFileInput")) {
            document.getElementById("uploadFileInput").click()
            registryLogOld('click_uploadDocuments' , "running-expert/job-details")
            registryLog('job_details', "click", "upload_documents")
        }
    }


    const onDocumentDownloadClick = (docId) => {
        console.log(docId)
        if (docId) {
            setFileIdToDownload(docId)
        }
    }

    return (
        <CardMargin>
            <FlexWrap width="100%" alignItems="center" flexDirection='row' justifyContent="space-between">
                <Subtitle>{t('Document Quick Access')}</Subtitle>
                <IconButton isLoading={isFileUploading} backgroundColor="primary" color="white" onClick={onDocumentUploadClick}>
                    <input type="file" id="uploadFileInput" onChange={onFileInputChange} hidden></input>

                    {!isFileUploading ?
                        <AppIcon src={documentIcon} width="24px" height="24px">
                        </AppIcon> : null
                    }

                    {t('Upload Document')}
                </IconButton>
            </FlexWrap>
            <FlexView width="100%" alignItems="center" flexDirection='row' justifyContent="flex-start" flexWrap="wrap">
                {
                    docs && docs.map((doc, i) => (
                        <DocPlaceholder onClick={() => onDocumentDownloadClick(doc.id)} key={i} flexDirection="column" backgroundColor="#F5F5F5" alignSelf="stretch" >
                            <DocPlaceholderImage src={documentIcon} width="90px" height="90px"></DocPlaceholderImage>
                            <h5 className="docName">{doc.name}</h5>
                            <p className="lastModification"> {t('Last Modification on') + ' '} {doc.uploadDate}</p>
                        </DocPlaceholder>
                    ))
                }
            </FlexView>


            <Modal isOpen={isUploadDialogOpen} onOutsideClick={closeModal}>
                <Card width="600px">
                    <h3> {t('Please Add a Description for the File') + ': '}</h3>
                    <h6 style={{ margin: "5px" }}>{file.name}</h6>
                    <h6 style={{ margin: "5px 0 0 0" }}>* {t('Description')}:</h6>
                    <TextArea width="80%" placeholder={t('Description')} value={fileDescription} onChange={(e) => setFileDescription(e.target.value)} />
                    <h6 style={{ margin: "5px" }} >{t("If this document is linked to a specific pipe, please enter the pipe's barcode number below") + ': ' }</h6>
                    <Input width="80%" placeholder="Pipe 00001" value={filePipe} onChange={(e) => setFilePipe(e.target.value)} />
                    <FlexView flexDirection="row" alignSelf="stretch" justifyContent="flex-end" margin="16px 0px 0px">
                        <Button margin="0px" onClick={closeModal}>{t('Cancel')}</Button>
                        <Button margin="0px 0px 0px 16px" backgroundColor="success" color="white" disabled={!fileDescription} onClick={uploadFile}>{t('Upload')}</Button>
                    </FlexView>
                </Card>
            </Modal>
        </CardMargin>

    )
}

export default DocumentsQuickAccess
